var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ScallopedImage from '@marketing/components/global/misc/ScallopedImage';
import Heading from '@marketing/components/global/typography/Heading';
import FlexSection from '@marketing/components/sections/FlexSection';
import { clsx } from 'clsx';
function TimelineItem(_a) {
    var title = _a.title, description = _a.description, imageData = _a.imageData, theme = _a.theme;
    var textStyle = theme === 'light' ? 'text-text-body' : 'text-white';
    return (_jsxs("div", __assign({ className: clsx('flex flex-col gap-xs-m w-full md:w-[269px]', textStyle) }, { children: [_jsxs("div", __assign({ className: "flex items-center gap-3xs-m" }, { children: [_jsx(ScallopedImage, { height: 132, imgData: imageData, theme: theme }), _jsx(Heading, __assign({ size: "sm", className: "text-left" }, { children: title }))] })), _jsx("p", __assign({ className: "text-left" }, { children: description }))] })));
}
function Timeline(_a) {
    var content = _a.content, _b = _a.backgroundColorStyle, backgroundColorStyle = _b === void 0 ? 'bg-surface-beige' : _b, _c = _a.theme, theme = _c === void 0 ? 'dark' : _c;
    var timelineItems = content.timelineItems;
    return (_jsx(FlexSection, __assign({ backgroundColorStyle: backgroundColorStyle, gapStyle: "gap-xs-m md:gap-lg-gutter", paddingStyle: "px-xs-m py-xl-m md:px-2xl-gutter md:py-lg-gutter" }, { children: timelineItems.map(function (item, index) { return (_jsx(TimelineItem, __assign({}, item, { theme: theme }), index)); }) })));
}
export default Timeline;
